const routes = [
  {
    path: "/users",
    component: () => import("views/User/List.vue"),
    name: "users",
    meta: { role: ["admin", "manager"] },
  },
];

export default routes;
